import React, { useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function FormDialog(props) {
    const {video, open, setOpen, onConfirm } = props;

    let videoInfos = video;

    const [titleValue, setTitleValue] = useState(video.contenu);
    const [linkValue, setLinkValue] = useState(video.arrayLink);
    const [titleValueEn, setTitleValueEn] = useState(video.contenu_en);
    const [linkValueEn, setLinkValueEn] = useState(video.arrayLink_en);

    const ontitleChange = (e) => setTitleValue(e.target.value);
    const onlinkChange = (e) => setLinkValue(e.target.value);
    const ontitleEnChange = (e) => setTitleValueEn(e.target.value);
    const onlinkEnChange = (e) => setLinkValueEn(e.target.value);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Modifier la capsule</DialogTitle>
        <DialogContent>
          <DialogContentText>
           Veuillez entrer les informations suivantes pour la modification de la capsule.
          </DialogContentText>
          <TextField
            autoFocus
            id="content"
            label="Titre video"
            fullWidth
            type="name"
            variant="standard"
            onChange={ontitleChange}
            value={titleValue}
          />
          <TextField
            id="link"
            label="Lien video YouTube"
            type="url"
            fullWidth
            variant="standard"
            onChange={onlinkChange}
            value={linkValue}
          />
          <TextField
            id="content_en"
            label="English title"
            type="name"
            fullWidth
            variant="standard"
            onChange={ontitleEnChange}
            value={titleValueEn}
          />
          <TextField
            id="link_en"
            label="English video YouTube link"
            type="url"
            fullWidth
            variant="standard"
            onChange={onlinkEnChange}
            value={linkValueEn}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            videoInfos.contenu = titleValue;
            videoInfos.arrayLink = linkValue;
            videoInfos.contenu_en = titleValueEn;
            videoInfos.arrayLink_en = linkValueEn;
            onConfirm(videoInfos);
            setOpen(false);
        }}>Confirm</Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}